import axios from "axios";
import {
  getConfigHeader,
  refrech,
  URL_DOCUMENT,
  URL_DOCUMENT_SAVE_MANY,
  URL_DOWNLOAD_FILE,
  URL_NOTIFY,
} from "./config";
import fileDownload from "js-file-download";

const findAll = async () => {
  return refrech()
    .then(() => axios.get(URL_DOCUMENT, getConfigHeader()))
    .catch((error) => Promise.reject(error));
};

const findAllBySalarie = async (id) => {
  return refrech()
    .then(() =>
      axios.get(URL_DOCUMENT + "?salarie_id=" + id, getConfigHeader())
    )
    .catch((error) => Promise.reject(error));
};

const findAllByClient = async (id) => {
  return refrech()
    .then(() => axios.get(URL_DOCUMENT + "?client_id=" + id, getConfigHeader()))
    .catch((error) => Promise.reject(error));
};

const deleteOne = async (id) => {
  return refrech()
    .then(() => axios.delete(URL_DOCUMENT + `?id=${id}`, getConfigHeader()))
    .catch((error) => Promise.reject(error));
};

const findOne = async (id) => {
  return refrech()
    .then(() => axios.get(URL_DOCUMENT + `?id=${id}`, getConfigHeader()))
    .catch((error) => Promise.reject(error));
};

const downloadfile = (filename, nameDownload = null) => {
  refrech()
    .then(() =>
      axios
        .get(URL_DOWNLOAD_FILE + `?filename=${filename}`, {
          ...getConfigHeader(),
          responseType: "blob",
        })
        .then((res) => {
          fileDownload(res.data, nameDownload ? nameDownload : filename);
        })
    )
    .catch((error) => Promise.reject(error));
};

const getfile = async (filename, type = "doc") => {
  if (type === "image") {
    return refrech()
      .then(() =>
        axios.get(URL_DOWNLOAD_FILE + `?logo=${filename}`, {
          ...getConfigHeader(),
          responseType: "blob",
        })
      )
      .catch((error) => Promise.reject(error));
  } else {
    return refrech()
      .then(() =>
        axios.get(URL_DOWNLOAD_FILE + `?filename=${filename}`, {
          ...getConfigHeader(),
          responseType: "blob",
        })
      )
      .catch((error) => Promise.reject(error));
  }
};

const save = async (doc) => {
  const formData = new FormData();

  for (const key in doc) {
    if (Object.hasOwnProperty.call(doc, key)) {
      const element = doc[key];
      formData.append(key, element);
    }
  }

  if (doc.file !== undefined) {
    formData.append("file", doc.file);
  } else {
    formData.delete("file");
  }

  return refrech()
    .then(() => axios.post(URL_DOCUMENT, formData, getConfigHeader()))
    .catch((error) => Promise.reject(error));
};

const notifyGestionnaire = async (notif) => {
  const formData = new FormData();

  for (const key in notif) {
    if (Object.hasOwnProperty.call(notif, key)) {
      const element = notif[key];
      formData.append(key, element);
    }
  }

  return refrech()
    .then(() => axios.post(URL_NOTIFY, formData, getConfigHeader()))
    .catch((error) => Promise.reject(error));
};

export const saveMany = async (client_id, details) => {
  const formData = new FormData();

  formData.append("client_id", JSON.stringify(client_id));

  for (var i = 0; i < details.length; i++) {
    var file = details[i];
    formData.append("details[]", file);
  }

  return refrech()
    .then(() => axios.post(URL_DOCUMENT_SAVE_MANY, formData, getConfigHeader()))
    .catch((error) => Promise.reject(error));
};

export {
  save,
  findAll,
  deleteOne,
  findOne,
  findAllBySalarie,
  findAllByClient,
  downloadfile,
  getfile,
  notifyGestionnaire,
};
